/* 
登录
*/
import APIDOC from '../model/serverApi';
import {get, post} from '../model/request';


export function login(params={}){
    return post(APIDOC.LOGIN.passwordLogin,params)
}

export function logOut(){
    return post(APIDOC.LOGIN.logout);
}
export function getAuthorityMenu(){//获取权限菜单
    console.log("run get getAuthorityMenu",APIDOC.LOGIN.getAuthorityMenu);
    return get(APIDOC.LOGIN.getAuthorityMenu)
}




// WEBPACK FOOTER //
// ./src/api/services/login.js